import Home from './components/home/Home';

const App = () => (
  <div className="App">
    <Home />
  </div>
);

export default App;
